module.exports = __webpack_public_path__ + "img/graden3.d0e5b849.png";